export default __webpack_public_path__ + "assets/fonts/b15f1f53f526257fc22852f51c638ee3.woff";